<template>
  <nav class="Paginator">

    <component class="Paginator-buttonLink"
      :is="reverseRoute ? 'router-link' : 'div'"
      :to="reverseRoute">

      <button-component class="Paginator-button"
        icon="arrow-left"
        :disabled="!reverseRoute" />

    </component>

    <p class="Paginator-pages"
      v-if="pagesLabel"
      v-html="pagesLabel">
    </p>

    <component class="Paginator-buttonLink"
      :is="forwardRoute ? 'router-link' : 'div'"
      :to="forwardRoute">

      <button-component class="Paginator-button"
        icon="arrow-right"
        :disabled="!forwardRoute" />

    </component>

  </nav>
</template>

<script>
export default {
  name: 'Paginator',

  props: {
    forwardRoute: {
      type: [Object, Boolean],
      default: false
    },
    reverseRoute: {
      type: [Object, Boolean],
      default: false
    },
    pagesLabel: {
      type: [String, Boolean]
    }
  }
}
</script>

<style>
@import 'properties';

.Paginator {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Paginator-buttonLink {
  display: block;
}

.Paginator-button {
  width: 30px;
  height: 30px;

  @media (min-width: 1025px) {
    width: 42px;
    height: 42px;
  }
}

.Paginator-button.Button--isDisabled {
  border-color: var(--c-grey-xxlt);
}

.Paginator-button svg {
  fill: var(--c-blue) !important;
}

.Paginator-button.Button--isDisabled svg {
  fill: var(--c-grey-xxlt) !important;
}

.Paginator-button .Icon {
  width: 16px !important;
  height: 16px !important;

  @media (min-width: 1025px) {
    width: 24px !important;
    height: 24px !important;
  }
}

.Paginator-pages {
  font-family: var(--font-family-sans);
  font-size: 11px;
  line-height: 24px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
</style>



// WEBPACK FOOTER //
// Paginator.vue?77b46fa2